import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Selectorispogzpkkfxv as Selector } from './Selector.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { default1jaun537xukbl as default_0 } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Defaults.mjs';
import { get_displayNamehv5zo902rjy4 as get_displayName } from './Annotations.mjs';
import {
  Never_getInstance3of1faxayn0qw as Never_getInstance,
  Always_getInstance177eud73uc475 as Always_getInstance,
  Companion_instance2q8fv6rz9kty0 as Companion_instance,
  Companion_instancen43ljy30xhzi as Companion_instance_0,
  Companion_instance1rxmb5wyn6fsk as Companion_instance_1,
  Companion_instance1x5ptgth8zhxi as Companion_instance_2,
  Companion_instance3sjn2yjp2itr2 as Companion_instance_3,
  Companion_instance27qzp1hsrgk5v as Companion_instance_4,
  Companion_instance2ofs92i7mv51v as Companion_instance_5,
  Companion_instance326hk1r71xax as Companion_instance_6,
  Companion_instanceph7m2qn20p7q as Companion_instance_7,
  Companion_instancetlzvdhi57ju2 as Companion_instance_8,
  Companion_instance2z7r598ruzfgp as Companion_instance_9,
  Companion_instanceh57sw6cyw523 as Companion_instance_10,
  Companion_instance1rv4h7xeh426o as Companion_instance_11,
  Companion_instance9b6acjoxpq0c as Companion_instance_12,
  Companion_instance3s54ycq8t72xu as Companion_instance_13,
  Companion_instance1xqhrale4ydxi as Companion_instance_14,
  Companion_instance2igigxyt265zn as Companion_instance_15,
  Companion_instanceheuor90dqw2p as Companion_instance_16,
  Companion_instancehonhf7q97gvq as Companion_instance_17,
  Companion_getInstance1r7wm1v3dq4i3 as Companion_getInstance,
  Companion_instancefyqtx24roelu as Companion_instance_18,
  Companion_instance15i08a3149tp6 as Companion_instance_19,
  Companion_instance2sjog5kofh6gw as Companion_instance_20,
  Companion_instance2j477vxcf0eam as Companion_instance_21,
  Companion_instance334xz54gwgpk7 as Companion_instance_22,
  Companion_instance2auwgabo579v8 as Companion_instance_23,
  Companion_instance28iz6ufuyency as Companion_instance_24,
  Companion_getInstance2w0ry8ukons4w as Companion_getInstance_0,
  Companion_getInstance2n1o7xahtwe38 as Companion_getInstance_1,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import { NothingSerializer3oixyyf77l4xt as NothingSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ConditionSerializer2v4zqxahhdocs as ConditionSerializer } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionSerialization.mjs';
import { first58ocm7j58k3q as first } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  get_centered31th09q7x90sf as get_centered,
  get_centeredVertically612wtasps5l3 as get_centeredVertically,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { NoSuchElementException679xzhnp5bpj as NoSuchElementException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_rem2p56fiaxda5jo as get_rem_0,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  Dimensions32ju1l7z4mh as Dimension,
  Companion_getInstance23x6zslwzj0st as Companion_getInstance_2,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { sizeConstraints19w9rda6g3rqz as sizeConstraints } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import {
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  weight31wqab1913ly4 as weight,
  textPopover3tarprbgmgxbr as textPopover,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Frame.commonHtml.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { RenderContextxikz99gtpuie as RenderContext } from './RenderContext.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl1tl9xt9sj2eem as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfbq6gzmblx5q7v as TextView$_set_content_$ref_pketfb,
} from '../auth/EmailProofComponent.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { MySealedClassSerializerInterface1lg9fzm3qtbhk as MySealedClassSerializerInterface } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/MySealedClassSerializer.mjs';
import {
  LabelGapSemantic_getInstance2wftjv243mafi as LabelGapSemantic_getInstance,
  LabelSemantic_getInstance4iffxvo6ijig as LabelSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import { text189ciz0cnr32o as text } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { errorText83fzxqvlxz6i as errorText } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import {
  cellFormub3o1hqp20e5 as cellForm,
  Renderer1fhwti5gmwutm as Renderer,
} from './Renderer.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function registerCondition(_this__u8e3s4) {
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, 'com.lightningkite.services.database.Condition'), ConditionRenderer_getInstance());
}
var ExtendedSubtypeDataClass;
function ExtendedSubtypeData() {
  if (ExtendedSubtypeDataClass === VOID) {
    class $ {
      constructor(serialName, niceName) {
        this.serialName_1 = serialName;
        this.niceName_1 = niceName;
      }
      toString() {
        return 'ExtendedSubtypeData(serialName=' + this.serialName_1 + ', niceName=' + this.niceName_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.serialName_1);
        result = imul(result, 31) + getStringHashCode(this.niceName_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ExtendedSubtypeData()))
          return false;
        if (!(this.serialName_1 === other.serialName_1))
          return false;
        if (!(this.niceName_1 === other.niceName_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ExtendedSubtypeData');
    ExtendedSubtypeDataClass = $;
  }
  return ExtendedSubtypeDataClass;
}
function ConditionRenderer$form$lambda$lambda(it) {
  return default_0(it.serializer_1);
}
function ConditionRenderer$form$lambda$lambda_0(it) {
  var tmp0_safe_receiver = ConditionRenderer_getInstance().get_extended_61huaa_k$(it);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.niceName_1;
  return tmp1_elvis_lhs == null ? get_displayName(it.serializer_1) : tmp1_elvis_lhs;
}
function ConditionRenderer$form$lambda$lambda$lambda(it) {
  return it;
}
var ConditionRendererClass;
function ConditionRenderer() {
  if (ConditionRendererClass === VOID) {
    class $ {
      constructor() {
        ConditionRenderer_instance = this;
        this.name_1 = 'Fill In The Blank';
        this.matchesSerializer_1 = 'com.lightningkite.services.database.Condition';
        this.never_1 = new (ExtendedSubtypeData())(Never_getInstance().serializer_9w0wvi_k$().get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'nothing');
        this.always_1 = new (ExtendedSubtypeData())(Always_getInstance().serializer_9w0wvi_k$().get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'everything');
        this.and_1 = new (ExtendedSubtypeData())(Companion_instance.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'and');
        this.or_1 = new (ExtendedSubtypeData())(Companion_instance_0.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'or');
        this.not_1 = new (ExtendedSubtypeData())(Companion_instance_1.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'not');
        this.equal_1 = new (ExtendedSubtypeData())(Companion_instance_2.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'is');
        this.notEqual_1 = new (ExtendedSubtypeData())(Companion_instance_3.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), "isn't");
        this.inside_1 = new (ExtendedSubtypeData())(Companion_instance_4.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'is one of');
        this.notInside_1 = new (ExtendedSubtypeData())(Companion_instance_5.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), "isn't one of");
        this.ifNotNull_1 = new (ExtendedSubtypeData())(Companion_instance_6.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'is present and');
        this.greaterThan_1 = new (ExtendedSubtypeData())(Companion_instance_7.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), '>');
        this.lessThan_1 = new (ExtendedSubtypeData())(Companion_instance_8.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), '<');
        this.greaterThanOrEqual_1 = new (ExtendedSubtypeData())(Companion_instance_9.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), '>=');
        this.lessThanOrEqual_1 = new (ExtendedSubtypeData())(Companion_instance_10.serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), '<=');
        this.listAllElements_1 = new (ExtendedSubtypeData())(Companion_instance_11.serializer_szze8_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'entries all');
        this.listAnyElements_1 = new (ExtendedSubtypeData())(Companion_instance_12.serializer_szze8_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'any entry');
        this.listSizesEquals_1 = new (ExtendedSubtypeData())(Companion_instance_13.serializer_szze8_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'size is');
        this.setAllElements_1 = new (ExtendedSubtypeData())(Companion_instance_14.serializer_szze8_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'entries all');
        this.setAnyElements_1 = new (ExtendedSubtypeData())(Companion_instance_15.serializer_szze8_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'any entry');
        this.setSizesEquals_1 = new (ExtendedSubtypeData())(Companion_instance_16.serializer_szze8_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'size is');
        this.exists_1 = new (ExtendedSubtypeData())(Companion_instance_17.serializer_r07i7m_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'has key');
        this.onKey_1 = new (ExtendedSubtypeData())(Companion_getInstance().serializer_r07i7m_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'where key');
        this.intBitsClear_1 = new (ExtendedSubtypeData())(Companion_instance_18.serializer_9w0wvi_k$().get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'has these bits cleared');
        this.intBitsSet_1 = new (ExtendedSubtypeData())(Companion_instance_19.serializer_9w0wvi_k$().get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'has these bits set');
        this.intBitsAnyClear_1 = new (ExtendedSubtypeData())(Companion_instance_20.serializer_9w0wvi_k$().get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'has any of these bits cleared');
        this.intBitsAnySet_1 = new (ExtendedSubtypeData())(Companion_instance_21.serializer_9w0wvi_k$().get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'has any of these bits set');
        this.geoDistance_1 = new (ExtendedSubtypeData())(Companion_instance_22.serializer_9w0wvi_k$().get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'distance is');
        this.stringContains_1 = new (ExtendedSubtypeData())(Companion_instance_23.serializer_9w0wvi_k$().get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'contains');
        this.regexMatches_1 = new (ExtendedSubtypeData())(Companion_instance_24.serializer_9w0wvi_k$().get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'matches regex');
        this.rawStringContains_1 = new (ExtendedSubtypeData())(Companion_getInstance_0().serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'contains');
        this.fullTextSearch_1 = new (ExtendedSubtypeData())(Companion_getInstance_1().serializer_qelnde_k$(NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'matches search');
        var tmp = this;
        // Inline function 'kotlin.collections.associateBy' call
        var this_0 = listOf([this.never_1, this.always_1, this.and_1, this.or_1, this.not_1, this.equal_1, this.notEqual_1, this.inside_1, this.notInside_1, this.ifNotNull_1, this.greaterThan_1, this.lessThan_1, this.greaterThanOrEqual_1, this.lessThanOrEqual_1, this.listAllElements_1, this.listAnyElements_1, this.listSizesEquals_1, this.setAllElements_1, this.setAnyElements_1, this.setSizesEquals_1, this.exists_1, this.onKey_1, this.intBitsClear_1, this.intBitsSet_1, this.intBitsAnyClear_1, this.intBitsAnySet_1, this.geoDistance_1, this.stringContains_1, this.regexMatches_1, this.rawStringContains_1, this.fullTextSearch_1]);
        var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
        // Inline function 'kotlin.collections.associateByTo' call
        var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity);
        var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          var tmp$ret$2 = element.serialName_1;
          destination.put_4fpzoq_k$(tmp$ret$2, element);
        }
        tmp.all_1 = destination;
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      priority_99v1an_k$(context, module_0) {
        return context.serializer_1.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$() === this.matchesSerializer_1 ? 1.0 : -1.0;
      }
      priority_yxj3hb_k$(context, module_0) {
        return this.priority_99v1an_k$(context, module_0);
      }
      columnWidth_v9zko3_k$(context, module_0) {
        return 20.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_v9zko3_k$(context, module_0);
      }
      get_extended_61huaa_k$(_this__u8e3s4) {
        return this.all_1.get_wei43m_k$(_this__u8e3s4.serializer_1.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$());
      }
      form_1l3m06_k$(context, value, module_0) {
        var tmp = context.serializer_1;
        var options = (tmp instanceof ConditionSerializer() ? tmp : THROW_CCE()).get_options_jecmyz_k$();
        return (_this__u8e3s4) => {
          var tmp = (it) => {
            // Inline function 'kotlin.collections.find' call
            var tmp0 = options;
            var tmp$ret$1;
            $l$block: {
              // Inline function 'kotlin.collections.firstOrNull' call
              var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
              while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
                var element = _iterator__ex2g4s.next_20eer_k$();
                if (element.isInstance_1(it)) {
                  tmp$ret$1 = element;
                  break $l$block;
                }
              }
              tmp$ret$1 = null;
            }
            var tmp0_elvis_lhs = tmp$ret$1;
            return tmp0_elvis_lhs == null ? first(options) : tmp0_elvis_lhs;
          };
          var type = value.lens_drj4fu_k$(tmp, ConditionRenderer$form$lambda$lambda);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(false);
          var tmp_0 = get_centered(element);
          // Inline function 'kotlin.collections.maxOf' call
          var iterator = options.iterator_jk1svi_k$();
          if (!iterator.hasNext_bitz1p_k$())
            throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
          var it = iterator.next_20eer_k$();
          var tmp0_safe_receiver = ConditionRenderer_getInstance().get_extended_61huaa_k$(it);
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.niceName_1;
          var maxValue = new (Dimension())(get_rem((tmp1_elvis_lhs == null ? get_displayName(it.serializer_1) : tmp1_elvis_lhs).length * 0.65));
          while (iterator.hasNext_bitz1p_k$()) {
            var it_0 = iterator.next_20eer_k$();
            var tmp0_safe_receiver_0 = ConditionRenderer_getInstance().get_extended_61huaa_k$(it_0);
            var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.niceName_1;
            var v = new (Dimension())(get_rem((tmp1_elvis_lhs_0 == null ? get_displayName(it_0.serializer_1) : tmp1_elvis_lhs_0).length * 0.65));
            if (compareTo(maxValue, v) < 0) {
              maxValue = v;
            }
          }
          var tmp$ret$7 = maxValue.value_1;
          // Inline function 'com.lightningkite.kiteui.views.card' call
          var this_0 = sizeConstraints(tmp_0, VOID, VOID, VOID, VOID, VOID, tmp$ret$7);
          // Inline function 'com.lightningkite.kiteui.views.direct.select' call
          var this_1 = themed(this_0, CardSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (Select())(this_1.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_1.willAddChild_hz2iwc_k$(element_0);
          var tmp_1 = _Constant___init__impl__v45mub(options);
          element_0.bind_64a41i_k$(type, new (Constant())(tmp_1), ConditionRenderer$form$lambda$lambda_0);
          element_0.onStartup_vrxh3i_k$();
          this_1.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
          var this_2 = weight(element, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (Frame())(this_2.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          this_2.willAddChild_hz2iwc_k$(element_1);
          var $this$frame = element_1;
          reactive($this$frame, VOID, ($this$reactive) => {
            var selectedType = $this$reactive.invoke_r7m7el_k$(type);
            $this$frame.clearChildren_eufjq4_k$();
            var tmp = selectedType.serializer_1;
            var subSerializer = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
            var subContext = new (RenderContext())(isInterface(subSerializer, KSerializer()) ? subSerializer : THROW_CCE(), context.fieldAnnotations_1);
            var tmp_0 = (it) => selectedType.isInstance_1(it) ? it : default_0(subSerializer);
            var subValue = value.lens_drj4fu_k$(tmp_0, ConditionRenderer$form$lambda$lambda$lambda);
            module_0.form_gqhwsi_k$(subContext, subValue)(get_centeredVertically($this$frame));
            return Unit_instance;
          });
          element_1.onStartup_vrxh3i_k$();
          this_2.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_1l3m06_k$(context, value, module_0);
      }
      view_nl8hr7_k$(context, value, module_0) {
        var tmp = context.serializer_1;
        var options = (tmp instanceof ConditionSerializer() ? tmp : THROW_CCE()).get_options_jecmyz_k$();
        return (_this__u8e3s4) => {
          var type = lens(value, (it) => {
            // Inline function 'kotlin.collections.find' call
            var tmp0 = options;
            var tmp$ret$1;
            $l$block: {
              // Inline function 'kotlin.collections.firstOrNull' call
              var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
              while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
                var element = _iterator__ex2g4s.next_20eer_k$();
                if (element.isInstance_1(it)) {
                  tmp$ret$1 = element;
                  break $l$block;
                }
              }
              tmp$ret$1 = null;
            }
            var tmp0_elvis_lhs = tmp$ret$1;
            return tmp0_elvis_lhs == null ? first(options) : tmp0_elvis_lhs;
          });
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(false);
          element.set_gap_jwjroq_k$(get_rem(0.25));
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          var this_0 = get_centered(element);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (TextView())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_0.willAddChild_hz2iwc_k$(element_0);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
          element_0.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
            var tmp0_safe_receiver = ConditionRenderer_getInstance().get_extended_61huaa_k$($this$invoke.invoke_r7m7el_k$(type));
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.niceName_1;
            return tmp1_elvis_lhs == null ? get_displayName($this$invoke.invoke_r7m7el_k$(type).serializer_1) : tmp1_elvis_lhs;
          });
          element_0.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
          var this_1 = weight(element, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (Frame())(this_1.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          this_1.willAddChild_hz2iwc_k$(element_1);
          var $this$frame = element_1;
          reactive($this$frame, VOID, ($this$reactive) => {
            var selectedType = $this$reactive.invoke_r7m7el_k$(type);
            $this$frame.clearChildren_eufjq4_k$();
            var tmp = selectedType.serializer_1;
            var subSerializer = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
            var subContext = new (RenderContext())(isInterface(subSerializer, KSerializer()) ? subSerializer : THROW_CCE(), context.fieldAnnotations_1);
            var subValue = lens(value, (it) => selectedType.isInstance_1(it) ? it : default_0(subSerializer));
            module_0.view_ntgxjz_k$(subContext, subValue)(get_centeredVertically($this$frame));
            return Unit_instance;
          });
          element_1.onStartup_vrxh3i_k$();
          this_1.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_nl8hr7_k$(context, value, module_0);
      }
      cellView_25q47v_k$(context, value, module_0) {
        var tmp = context.serializer_1;
        var serializer = isInterface(tmp, MySealedClassSerializerInterface()) ? tmp : THROW_CCE();
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => toString($this$invoke.invoke_r7m7el_k$(value)));
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      cellView_2dvin1_k$(context, value, module_0) {
        return this.cellView_25q47v_k$(context, value, module_0);
      }
      labeledForm_39ek3k_k$(context, value, module_0, label, description) {
        return (_this__u8e3s4) => {
          var tmp2 = label;
          // Inline function 'com.lightningkite.kiteui.forms.fieldWithoutBorder' call
          var description_0 = description;
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          element.set_themeChoice_py59um_k$(element.get_themeChoice_22tyn3_k$().plus_duvq05_k$(LabelGapSemantic_getInstance()));
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          element_0.set_vertical_nuap32_k$(false);
          element_0.set_gap_jwjroq_k$(get_rem(0.25));
          text(themed(get_centered(element_0), LabelSemantic_getInstance()), tmp2);
          if (!(description_0 == null)) {
            var tmp0 = textPopover(get_centered(element_0), description_0);
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            var icon = Companion_getInstance_2().info_1.resize_q1xpz0_k$(get_rem_0(1));
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_1 = new (IconView())(tmp0.get_context_h02k06_k$());
            ensureOutermostElement(element_1);
            tmp0.willAddChild_hz2iwc_k$(element_1);
            element_1.set_source_3o5lkf_k$(icon);
            element_1.set_description_s1386w_k$('Info');
            element_1.onStartup_vrxh3i_k$();
            tmp0.addChild_2qpft2_k$(element_1);
          }
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          ConditionRenderer_getInstance().form_1l3m06_k$(context, value, module_0)(element);
          errorText(element);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      labeledForm_ughtr2_k$(context, value, module_0, label, description) {
        return this.labeledForm_39ek3k_k$(context, value, module_0, label, description);
      }
      labeledView_euimp5_k$(context, value, module_0, label, description) {
        return (_this__u8e3s4) => {
          var tmp2 = label;
          // Inline function 'com.lightningkite.kiteui.forms.fieldWithoutBorder' call
          var description_0 = description;
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          element.set_themeChoice_py59um_k$(element.get_themeChoice_22tyn3_k$().plus_duvq05_k$(LabelGapSemantic_getInstance()));
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          element_0.set_vertical_nuap32_k$(false);
          element_0.set_gap_jwjroq_k$(get_rem(0.25));
          text(themed(get_centered(element_0), LabelSemantic_getInstance()), tmp2);
          if (!(description_0 == null)) {
            var tmp0 = textPopover(get_centered(element_0), description_0);
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            var icon = Companion_getInstance_2().info_1.resize_q1xpz0_k$(get_rem_0(1));
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_1 = new (IconView())(tmp0.get_context_h02k06_k$());
            ensureOutermostElement(element_1);
            tmp0.willAddChild_hz2iwc_k$(element_1);
            element_1.set_source_3o5lkf_k$(icon);
            element_1.set_description_s1386w_k$('Info');
            element_1.onStartup_vrxh3i_k$();
            tmp0.addChild_2qpft2_k$(element_1);
          }
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          ConditionRenderer_getInstance().view_nl8hr7_k$(context, value, module_0)(element);
          errorText(element);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      labeledView_aldyvt_k$(context, value, module_0, label, description) {
        return this.labeledView_euimp5_k$(context, value, module_0, label, description);
      }
    }
    protoOf($).cellForm_4mayde_k$ = cellForm;
    initMetadataForObject($, 'ConditionRenderer', VOID, VOID, [Renderer()]);
    ConditionRendererClass = $;
  }
  return ConditionRendererClass;
}
var ConditionRenderer_instance;
function ConditionRenderer_getInstance() {
  if (ConditionRenderer_instance === VOID)
    new (ConditionRenderer())();
  return ConditionRenderer_instance;
}
//region block: exports
export {
  registerCondition as registerCondition1a18tvlf3klb0,
};
//endregion

//# sourceMappingURL=ConditionRenderer.mjs.map
